<div>
  <p-table #dt1 [scrollDirection]="'horizontal'" [scrollDirection]="'horizontal'"
      [ngStyle]="{'--disabled-table-border': (isTableBorderDisabled ? 'none' : '1px solid #dee2e6') }"
      styleClass="shared-table-style" [loading]="loading" [resizableColumns]="true" [scrollable]="true"
      styleClass="p-datatable-sm p-datatable-gridlines" [reorderableColumns]="reorderColumns" (onColReorder)="onColReorder($event)" [columns]="columns"
      [value]="rows" [globalFilterFields]="getGlobalFilterFields(columns)" [selectionMode]="selectionMode"
      [(selection)]="selectedRow" [rowStyleClass]="getRowClass" (onRowSelect)="onRowSelect($event)"
      (onRowUnselect)="onRowUnselect($event)" (onColResize)="onColumnResize($event)">

      <ng-template pTemplate="colgroup" let-columns>
         <colgroup>
            <col *ngFor="let col of columns" [style.width.px]="col.width" [style.display]="col.display">
         </colgroup>
      </ng-template>

      <ng-template *ngIf="showCaption" pTemplate="caption">
         <div class="table-caption">
            <span class="table-title" *ngIf="tableHeader">
               {{ tableHeader }}
               </span>
         
            <ng-content [select]="[globalFilter]">
            </ng-content>
         </div>
     
      </ng-template>
      <ng-template pTemplate="header" let-columns>
   <tr [ngClass]="disableTable?'disableBg':''">
      <ng-container *ngIf="showColumns">
         <th *ngFor="let col of columns" pFrozenColumn [frozen]="col.frozen" pReorderableColumn
            pResizableColumn [ngStyle]="{'display': col.display}">

            <ng-container *ngIf="col.columnType == 15 && selectionMode === 'multiple'; else headerText">
               <p-checkbox [(ngModel)]="selectAllChecked" [binary]="true"
                  [disabled]="disableTable"
                  (onChange)="onSelectAllChange($event)">
               </p-checkbox>
            </ng-container>
            <ng-template #headerText>
               {{ col.header }}
            </ng-template>
            
                  <!-- Sortable column template -->
                  <ng-container *ngIf="col.sortableColumn">
                     <i class="pi" [ngClass]="getSortIcon(col.field)" (click)="onSortIconClick(col.field)"
                        style="cursor: pointer; margin-left: 5px;">
                     </i>
                  </ng-container>

                  <ng-container *ngIf="col.filter">
                     <!-- Dynamic Filter -->
                     <p-columnFilter [field]="col.field" [matchMode]="col.filterMatchMode || 'in'" display="menu"
                        [showMatchModes]="false" [showOperator]="false" [showClearButton]="false"
                        [showApplyButton]="false" [showAddButton]="false">
                        <ng-template pTemplate="header">
                           <div class="px-3 pt-3 pb-0">
                              <span class="font-bold">{{ col.filterHeader || col.header + ' Filter' }}</span>
                           </div>
                        </ng-template>
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                           <!-- Multi-select Filter -->
                           <p-dropdown #customFilterDropdown [(ngModel)]="col.value" [options]="col.filterOptions"
                              placeholder="Select a filter" (ngModelChange)="onDropdownChangeFilter($event)">
                           </p-dropdown>

                        </ng-template>
                     </p-columnFilter>
                  </ng-container>
               </th>
            </ng-container>
         </tr>
      </ng-template>


      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">

         <!-- Row template for Skeleton loader -->
         <tr *ngIf="showTableSkeleton">
            <ng-container *ngFor="let col of columns">
               <td *ngIf="col.display != 'none'">
                  <p-skeleton></p-skeleton>
               </td>
            </ng-container>
         </tr>

         <tr *ngIf="!showTableSkeleton" [class.disabled-row]="rowData.disabled"
            [class.striped-row]="rowData['highlightCell'] === true" [class.disableBg]="disableTable"
            [class.selected-row]="!rowData.disabled && enableRowSelectionStyle && rowData[checkboxField]"
            [class.mandatory-missing]="rowData.__missing" [ngStyle]="getRowStyle(rowData)"
            (click)="!rowData.disabled && enableRowClick && onRowClick($event, rowData)"
            [pSelectableRow]="!separateRowAndCheckboxClick && !rowData.disabled ? rowData : null"
            [pSelectableRowIndex]="!separateRowAndCheckboxClick && !rowData.disabled ? rowIndex : null">
            <td *ngIf="rowData.showRegionCell" [attr.rowspan]="rowData.regionRowSpan"
               class="merged-region-cell text-center align-middle">
               {{ rowData.GROUP_NAME }}
            </td>
            <ng-container *ngIf="columnLevelEdit">
               <ng-container *ngFor="let col of columns">

                  <td *ngIf="col.columnType == 0 && !disableTable &&!col.mergeRows "
                     [ngStyle]="getCellStyle(rowData, col)" [ngClass]="getTextAlignmentClass(col.dataType)">
                     {{ rowData[col.field] }}
                  </td>

                  <!-- Template for dotted Loader animation -->
                  <td *ngIf="col.columnType == 7" [ngStyle]="{'display': col.display}"
                     [ngClass]="getTextAlignmentClass(col.dataType)">
                     <div *ngIf="showLoadingColumn; else MAN" style="margin-left: 25%" class="loader"></div>
                     <ng-template #MAN>
                        {{ rowData[col.field] }}
                     </ng-template>
                  </td>

                  <td *ngIf="col.columnType == 8" [ngStyle]="{'display': col.display}">
                     <ng-container *ngIf="rowData[col.field]">
                        <!-- Render hyperlink if showHyperlink is true -->
                        <ng-container *ngIf="col.showHyperlink">
                           <a [routerLink]="rowData[col.linkField]">
                              {{ rowData[col.field] }}
                           </a>
                        </ng-container>

                        <!-- Render plain text if showHyperlink is false -->
                        <ng-container *ngIf="!col.showHyperlink">
                           {{ rowData[col.field] }}
                        </ng-container>

                        <!-- Logo link and part price history icon -->
                        <a *ngIf="rowData[col.logoField]" [href]="rowData[col.logoField]" target="_blank">
                           <img src="../assets/oas-logo.png" alt="OAS Logo"
                              style="width: 20px; height: 20px; margin-left: 15px;">
                        </a>
                        <i style="width: 20px; height: 20px; margin-left: 15px;"
                           (click)="onHistoryLogoClick(rowIndex, col.field, rowData)" class="pi pi-history">
                        </i>
                     </ng-container>
                  </td>



                  <!-- Template for Text and Image Link -->
                  <td *ngIf="col.columnType == 9" [ngStyle]="{'display': col.display}">
                     {{ rowData[col.field] }}
                     <a [href]="rowData['hyperlinkLogoeco']" target="_blank">
                        <img src="../assets/oas-logo.png" alt="OAS Logo"
                           style="width: 20px; height: 20px;  margin-left: 15px;">
                     </a>
                  </td>

                  <!-- Template for image  -->
                  <td *ngIf="col.columnType == 10">
                     <img [src]="rowData['IMAGE']" [alt]="rowData['IMAGEAlt']" [style]="rowData['IMAGEStyle']" />
                  </td>

                  <!-- Test ngModelChange -->
                  <!-- Template for Dropdown with Text and Image(s) -->
                  <td *ngIf="col.columnType == 11">
                     <div style="display: flex; align-items: center; width: 100%;">
                        <img [title]="rowData.tooltipText" *ngIf="rowData.imageUrl" [src]="rowData.imageUrl" alt="Icon"
                           style="width: 45px; height: 35px;margin-right: 4px; object-fit: contain;">
                        <ng-container *ngIf="rowData.imageUrls?.length">
                           <img *ngFor="let img of rowData.imageUrls; let i = index" [src]="img" [alt]="'Icon ' + i"
                              [title]="rowData.tooltipText[i]"
                              style="width: 45px; height: 35px; margin-right: 4px; object-fit: contain;">
                        </ng-container>
                        <div class="editable-dropdownn" *ngIf="rowData.showDropdown">
                           <p-dropdown [(ngModel)]="rowData[col.field]" [autoWidth]="true" appendTo="body"
                              [class.disabled-row]="rowData.disabled" class="editable-dropdown"
                              [options]="rowData[col.field+'Dropdown']" optionValue="code" optionLabel="name"
                              (ngModelChange)="onDropdownChange($event, col.field, rowData)"
                              [placeholder]="placeholder">
                           </p-dropdown>
                        </div>
                        <p style="margin-left: 12px">{{rowData['Text']}}</p>
                     </div>
                  </td>

                  <td *ngIf="col.columnType == 21">
                     <div style="display: flex; align-items: center;">
                        <ng-container *ngFor="let icon of rowData.REASONS_ICONS">
                           <div (click)="!rowData.disabled && (icon.selected = !icon.selected)" [ngStyle]="{
          'background-color': icon.selected ? '#036B78' : 'transparent',
          'border-radius': '50%',
          'padding': '6px',
          'margin-right': '8px',
          'cursor': 'pointer',
          'transition': 'all 0.2s ease'
        }">
                              <i [ngClass]="icon.iconClass" [title]="icon.tooltipText"
                                 [style.color]="icon.selected ? '#fff' : '#8c8c8c'" style="font-size: 1.2rem;"></i>
                           </div>
                        </ng-container>
                     </div>
                  </td>


                  <!-- Template for Dropdown -->
                  <td *ngIf="col.columnType == 12" [ngClass]="getTextAlignmentClass(col.dataType)">
                     <div class="editable-dropdownn" *ngIf="rowData.showSimpleDropdown">
                        <p-dropdown [style]="{'width':'100%'}" [(ngModel)]="rowData[col.field]" [autoWidth]="true"
                           appendTo="body" class="editable-dropdown" [options]="rowData[col.field+'Dropdown']"
                           optionValue="code" optionLabel="name" [placeholder]="placeholder"
                           [disabled]="disableTable || (rowData['DISABLE_' + col.field] !== undefined ? rowData['DISABLE_' + col.field] : rowData.disabled)"
                           (ngModelChange)="onDropdownChange($event, col.field, rowData)">
                        </p-dropdown>
                     </div>
                  </td>

                  <td *ngIf="col.columnType == 22" [ngClass]="getTextAlignmentClass(col.dataType)">
                     <div class="editable-dropdownn" *ngIf="rowData.showSimpleDropdown">
                        <p-dropdown [style]="{'width':'80%'}" [(ngModel)]="rowData[col.field]" [autoWidth]="true"
                           appendTo="body" class="editable-dropdown" [options]="rowData[col.field+'Dropdown']"
                           optionValue="code" optionLabel="name" [disabled]="rowData.disabled"
                           (onChange)="onDecidedChange(rowData)" [placeholder]="placeholder">
                        </p-dropdown>
                     </div>
                  </td>


                  <td *ngIf="col.columnType == 24" [ngStyle]="{'display': col.display, 'text-align': 'center'}">
                     <neo-matris-button [buttonText]="'Copy'" [buttonStyle]="{
                              'font-size': '0.75rem',
                              'padding': '0.2rem 0.4rem',
                              'height': '1.6rem'
                        }" (buttonClick)="onCopyOrder(rowData)">
                     </neo-matris-button>
                  </td>
                  <td *ngIf="col.columnType == 25" [ngClass]="getTextAlignmentClass(col.dataType)">
                     <div class="editable-dropdownn" *ngIf="rowData.showSimpleDropdown">
                        <p-dropdown [style]="{'width':'100%'}" [(ngModel)]="rowData[col.field]" appendTo="body" class="editable-dropdown"
                           [options]="rowData[col.field+'Dropdown']" optionValue="code" optionLabel="name" [filter]="true" filterBy="name"
                           [showClear]="col.showClear ?? false" (ngModelChange)="onDropdownChange($event, col.field, rowData)"
                           [disabled]="disableTable || (rowData['DISABLE_' + col.field] !== undefined ? rowData['DISABLE_' + col.field]: rowData.disabled)">
                        </p-dropdown>
                     </div>
                  </td>


                  <!-- Template for search field -->
                  <td *ngIf="col.columnType == 13" [ngClass]="getTextAlignmentClass(col.dataType)">
                     <div style="display: flex; align-items: center; justify-content: space-between;">
                        <span>{{ rowData[col.field] }}</span>
                        <i class="pi pi-search">
                        </i>
                     </div>
                  </td>

                  <!-- Template for selecting lead // star icon selection -->
                  <td *ngIf="col.columnType == 14" [ngClass]="getTextAlignmentClass(col.dataType)">
                     <div *ngFor="let item of rowData[col.field]; let itemIndex = index" class="star-container"
                        style="display: flex; align-items: center; justify-content: flex-start; gap: 4px;">

                        <span
                           [ngStyle]="{'font-weight': getStarClass(rowIndex, col.field, item) === 'pi pi-star-fill text-yellow-500' ? 'bold' : 'normal'}"
                           style="margin-right: 4px;">
                           {{ item }}
                        </span>

                        <div style="display: flex; align-items: center;">
                           <i *ngIf="!lockTable || getStarClass(rowIndex, col.field, item) === 'pi pi-star-fill text-yellow-500'"
                              [ngClass]="[getStarClass(rowIndex, col.field, item), lockTable ? 'disabled' : '']"
                              class="cursor-pointer" (click)="toggleStar(rowIndex, col.field, item, rowData)">
                           </i>

                           <i *ngIf="!lockTable" class="pi pi-trash cursor-pointer text-red-500"
                              style="margin-left: 4px;" (click)="deleteItem(rowData, col.field, itemIndex)">
                           </i>

                           <!-- Edit -->
                           <i *ngIf="!lockTable" class="pi pi-pencil cursor-pointer text-blue-500"
                              style="margin-left: 4px;" (click)="openEditDialog(rowData, item, rowIndex, col.field)">
                           </i>
                        </div>
                     </div>

                     <!-- Add Team Member (placed after the last item) -->
                     <div style="display: flex; justify-content: flex-start; margin-top: 8px;">
                        <i *ngIf="!lockTable" class="pi pi-plus cursor-pointer text-green-500"
                           (click)="onAddTeamMember(rowData, col.field, rowIndex)" title="Add Team Member">
                        </i>
                     </div>
                  </td>

                  <!-- Template for Checkbox -->
                  <!-- <td *ngIf="col.columnType == 15" [ngClass]="getTextAlignmentClass(col.dataType)">
                     <p-checkbox [(ngModel)]="rowData[col.field]" [binary]="true"
                        (onChange)="onCheckboxChange($event, col.field, rowData)">
                     </p-checkbox>
                  </td> -->

                  <!-- Checkbox Column Template -->
                  <td pFrozenColumn [frozen]="col.frozen" *ngIf="col.columnType == 15  && selectionMode === 'multiple'"
                     [ngClass]="getTextAlignmentClass(col.dataType)">
                     <div class="checkbox-cell-wrapper">
                        <div class="my-checkbox-wrapper">
                           <p-checkbox [(ngModel)]="rowData[col.field]" [binary]="true"
                              (onChange)="onCheckboxChange($event, col.field, rowData)"
                              [disabled]="disableTable || rowData.checkboxDisabled"
                              (click)="$event.stopPropagation()">
                           </p-checkbox>
                        </div>
                     </div>
                  </td>

                  <td *ngIf="col.columnType == 26" [ngStyle]="{'display': col.display, 'text-align': 'center'}">
                     <button type="button" class="p-button p-button-text p-button-sm" title="View row details"
                        aria-label="View row details" (click)="$event.stopPropagation(); viewRow.emit(rowData)">
                        <i class="pi pi-eye" aria-hidden="true"></i>
                     </button>
                  </td>

                  <!-- Radio Button Column (Single selection) -->
                  <td *ngIf="col.columnType == 16" [ngClass]="getTextAlignmentClass(col.dataType)">
                     <div class="checkbox-cell-wrapper">
                        <p-radioButton name="singleSelectionGroup" [value]="rowData"
                           [(ngModel)]="selectedRowForSingleSelection" (onClick)="onRadioSelect(col.field, rowData)">
                        </p-radioButton>
                     </div>
                  </td>

                  <!-- <td *ngIf="col.columnType == 20" [ngStyle]="{'display': col.display}">Not requested</td> -->

                  <!-- <td *ngIf="col.columnType == 20" [ngStyle]="{'display': col.display, 'text-align': 'center', 'vertical-align': 'middle'}">
               <neo-matris-button [buttonText]="rowData[col.field]" [buttonStyle]="{ 'font-size': '0.8rem', 'padding': '0.25rem 0.25rem', 'height': '1.2rem', 'width': '50%', 'justify-content': 'center' }"
                     [disabled]="rowData[col.field] !== 'Not Requested'"  (buttonClick)="openCreateSourcingProjectDialog(rowData)">
               </neo-matris-button>
            </td> -->
                  <!-- <td *ngIf="col.columnType == 20" 
    [ngStyle]="{'display': col.display, 'text-align': 'center', 'vertical-align': 'middle'}">

  <neo-matris-button 
      *ngIf="rowData[col.field] === 'Not Requested' || rowData[col.field] === 'FAILED'"
      [buttonText]="rowData[col.field]" 
      [buttonStyle]="{ 'font-size': '0.8rem', 'padding': '0.25rem 0.25rem', 'height': '1.2rem', 'width': '50%', 'justify-content': 'center' }"
      (buttonClick)="openCreateSourcingProjectDialog(rowData)">
  </neo-matris-button>

  <span *ngIf="rowData[col.field] !== 'Not Requested' && rowData[col.field] !== 'FAILED'">
    {{ rowData[col.field] }}
  </span>

</td> -->
                  <td *ngIf="col.columnType == 20"
                     [ngStyle]="{'display': col.display, 'text-align': 'center', 'vertical-align': 'middle'}">

                     <!-- Show button if Not Requested or FAILED -->
                     <neo-matris-button
                        *ngIf="rowData[col.field] === 'Not Requested' || rowData[col.field] === 'FAILED'"
                        [buttonText]="rowData[col.field]"
                        [buttonStyle]="{ 'font-size': '0.8rem', 'padding': '0.25rem 0.25rem', 'height': '1.2rem', 'width': '50%', 'justify-content': 'center' }"
                        (buttonClick)="openCreateSourcingProjectDialog(rowData)">
                     </neo-matris-button>

                     <!-- Show ID + history icon if it exists -->
                     <span *ngIf="rowData[col.field] !== 'Not Requested' && rowData[col.field] !== 'FAILED'">
                        {{ rowData[col.field] }}

                        <!-- History icon -->
                        <i *ngIf="rowData[col.field]" class="pi pi-history" (click)="onHistoryClick($event, rowData)"
                           style="font-size: 0.9rem; cursor: pointer; color: rgb(77,77,77); margin-left: 5px;">
                        </i>

                     </span>

                  </td>


                  <td disable="disableTable"
                     *ngIf="((col.columnType == 0 || col.columnType == 1 || col.columnType == 2 || col.columnType == 3 ||col.columnType == 4 ||col.columnType == 6 ) && disableTable )"
                     [ngClass]="getTextAlignmentClass(col.dataType)">
                     {{ rowData[col.field] }}
                  </td>

                  <td *ngIf="col.columnType == 5">
                     <a [routerLink]="rowData['hyperlinkText']">{{ rowData[col.field] }}</a>
                  </td>



                  <td pFrozenColumn [frozen]="col.frozen" *ngIf="col.columnType == 18"
                     [ngStyle]="{'display': col.display}" [style.width]="col.width">
                     <a [routerLink]="rowData[col.linkField]" class="view-link-tour">
                        <i class="pi pi-search" style="font-size: x-small;"></i> View
                     </a>
                  </td>
                  <td [pEditableColumn]="rowData[col.field]" pEditableColumnField="col.field"
                     *ngIf="col.columnType == 1 && !disableTable" [ngClass]="getTextAlignmentClass(col.dataType)">
                     <div class="editable-dropdownn">
                        <p-cellEditor>
                           <ng-template let-rowIndex="rowIndex" pTemplate="input">
                              <p-dropdown [style]="{'width':'100%'}" [(ngModel)]="rowData[col.field]" [autoWidth]="true"
                                 appendTo="body" class="editable-dropdown" [options]="rowData[col.field+'Dropdown']"
                                 optionValue="code" optionLabel="name"
                                 (ngModelChange)="onDropdownChange($event, col.field, rowData)"
                                 [placeholder]="placeholder">
                              </p-dropdown>
                           </ng-template>
                           <!-- <ng-template pTemplate="output">
                              {{ rowData[col.field] }}
                           </ng-template> -->
                           <ng-template pTemplate="output">
                              {{ getDropdownDisplayName(rowData, col.field) }}
                           </ng-template>
                        </p-cellEditor>
                     </div>
                  </td>

                  <td [pEditableColumn]="rowData[col.field]" pEditableColumnField="col.field"
                     *ngIf="col.columnType == 2 && !disableTable" [ngClass]="getTextAlignmentClass(col.dataType)">
                     <div class="editable-datepickerr">
                        <p-cellEditor>
                           <ng-template let-rowIndex="rowIndex" pTemplate="input">
                  <td>
                     <input style="font-size: 0.8rem;" pInputText min="0" class="input-custom" type="text"
                        [(ngModel)]="rowData[col.field]" [maxlength]="col.maxLength || null"
                        (keypress)="validateNumberInput($event, rowData, col.field)"
                        (blur)="formatNumberInput(rowData, col.field)" (input)="enforceMaxLength($event, col.maxLength)"
                        [attr.maxlength]="col.maxLength || null" />
                  </td>
      </ng-template>
      <ng-template pTemplate="output">
         {{ rowData[col.field] }}
      </ng-template>
      </p-cellEditor>
</div>
</td>

<!-- Template for Package ID RouterLink -->
<td *ngIf="col.columnType == 19" [ngStyle]="{'display': col.display}">
   <a [routerLink]="['/part-package/package-details', rowData['PACKAGEID']]">
      {{ rowData['PACKAGEID'] }}
   </a>
</td>

<td *ngIf="col.columnType==23" [ngStyle]="{'display': col.display}">
   <neo-matris-button [buttonText]="'Remove'" [buttonStyle]="{ 'height' : '1.2rem'}"
      (buttonClick)="deleteItem(rowData, col.field, 0)"></neo-matris-button>
</td>

<td [pEditableColumn]="rowData[col.field]" pEditableColumnField="col.field" *ngIf="col.columnType == 6 && !disableTable"
   [ngClass]="getTextAlignmentClass(col.dataType)">
   <div class="editable-datepickerr">
      <p-cellEditor>
         <ng-template let-rowIndex="rowIndex" pTemplate="input">
<td>
   <input style="font-size: 0.8rem;" appInputMaxvalue pInputText min="0" class="input-custom" type="number"
      [(ngModel)]="rowData[col.field]" />
</td>
</ng-template>
<ng-template pTemplate="output">
   {{ rowData[col.field] }}
</ng-template>
</p-cellEditor>
</div>
</td>

<td [pEditableColumn]="rowData[col.field]" pEditableColumnField="col.field" *ngIf="col.columnType == 3 && !disableTable"
   [ngClass]="getTextAlignmentClass(col.dataType)">
   <div class="editable-datepickerr">
      <p-cellEditor>
         <ng-template let-rowIndex="rowIndex" pTemplate="input">
            <p-calendar [style]="{'width':'100%'}" [showButtonBar]="true" dateFormat="yy-mm-dd"
               styleClass="editable-datepicker" [(ngModel)]="rowData[col.field]" appendTo="body"
               [disabled]="disableTable || (rowData['DISABLE_' + col.field] !== undefined ? rowData['DISABLE_' + col.field] : rowData.disabled)"
               (ngModelChange)="onDateChange($event, col.field, rowData)">
            </p-calendar>
         </ng-template>
         <ng-template pTemplate="output">
            {{ rowData[col.field] | date : 'yyyy-MM-dd' }}
         </ng-template>
      </p-cellEditor>
   </div>
</td>

<td [pEditableColumn]="rowData[col.field]" pEditableColumnField="col.field" 
   [pEditableColumnDisabled]="rowData['DISABLE_' + col.field] !== undefined ? rowData['DISABLE_' + col.field] : rowData.disabled"
   *ngIf="col.columnType == 4 && !disableTable"
   [ngClass]="getTextAlignmentClass(col.dataType)" (click)="$event.stopPropagation()">
   <div class="editable-datepickerr">
      <p-cellEditor>
         <ng-template let-rowIndex="rowIndex" pTemplate="input">
<td>
   <input style="font-size: 0.8rem;" pInputText min="0" class="input-custom" type="text"
      [(ngModel)]="rowData[col.field]" (click)="$event.stopPropagation()"
      (ngModelChange)="onInputChange($event, col.field, rowData)"
      (blur)="handleBlur($event, col.field, rowData)"
      (keydown.enter)="noteEnter.emit({ event: $event, row: rowData }); $event.stopPropagation()" />

</td>
</ng-template>
<ng-template pTemplate="output">
   {{ rowData[col.field] }}
</ng-template>
</p-cellEditor>
</div>
</td>

<td [pEditableColumn]="rowData[col.field]" pEditableColumnField="col.field"
   [pEditableColumnDisabled]="!rowData.isSelected" *ngIf="col.columnType == 17 && !disableTable"
   [ngClass]="getTextAlignmentClass(col.dataType)">
   <div class="editable-datepickerr">
      <p-cellEditor>
         <ng-template let-rowIndex="rowIndex" pTemplate="input">
            <input style="font-size: 0.8rem;" pInputText min="0" class="input-custom" type="text"
               [(ngModel)]="rowData[col.field]" />
         </ng-template>
         <ng-template pTemplate="output">
            {{ rowData[col.field] }}
         </ng-template>
      </p-cellEditor>
   </div>
</td>

</ng-container>
</ng-container>
<ng-container *ngIf="rowLevelEdit">
   <ng-container *ngFor="let col of columns">
      <!-- Checkbox Column -->
        <td
            pFrozenColumn
            [frozen]="col.frozen"
            *ngIf="col.columnType == 15 && selectionMode === 'multiple'"
            [ngClass]="getTextAlignmentClass(col.dataType)">
            <div class="checkbox-cell-wrapper">
                <div class="my-checkbox-wrapper">
                    <p-checkbox
                        [(ngModel)]="rowData[col.field]"
                        [binary]="true"
                        (onChange)="onCheckboxChange($event, col.field, rowData)"
                        [disabled]="disableTable || rowData.checkboxDisabled"
                        (click)="$event.stopPropagation()">
                    </p-checkbox>
                </div>
            </div>
        </td>
        <!-- Normal read-only column -->
        <td
            *ngIf="col.columnType != 15 && rowData[col.field+'ControlType'] == undefined"
            [ngClass]="getTextAlignmentClass(col.dataType)">
            {{ getDropdownDisplayName(rowData, col.field) }}
        </td>
        <td
            *ngIf="col.columnType != 15 && rowData[col.field+'ControlType'] == 0"
            [ngClass]="getTextAlignmentClass(col.dataType)">
            {{ rowData[col.field] }}
        </td>

      <td [pEditableColumn]="rowData[col.field]" pEditableColumnField="col.field"
         *ngIf="rowData[col.field+'ControlType'] == 1" [ngClass]="getTextAlignmentClass(col.dataType)">
         <div class="editable-dropdownn">
            <p-cellEditor>
               <ng-template let-rowIndex="rowIndex" pTemplate="input">
                  <p-dropdown [style]="{'width':'100%'}" [(ngModel)]="rowData[col.field]" [autoWidth]="true"
                     appendTo="body" class="editable-dropdown" [options]="rowData[col.field+'Dropdown']"
                     optionValue="code" optionLabel="name"
                     (ngModelChange)="onDropdownChange($event, col.field, rowData)" [placeholder]="placeholder">
                  </p-dropdown>
               </ng-template>
               <!-- <ng-template pTemplate="output">
                  {{ rowData[col.field] }}
               </ng-template> -->
               <ng-template pTemplate="output">
                  {{ getDropdownDisplayName(rowData, col.field) }}
               </ng-template>
            </p-cellEditor>
         </div>
      </td>

      <td [pEditableColumn]="rowData[col.field]" pEditableColumnField="col.field"
         *ngIf="rowData[col.field+'ControlType'] == 2" [ngClass]="getTextAlignmentClass(col.dataType)">
         <div class="editable-datepickerr">
            <p-cellEditor>
               <ng-template let-rowIndex="rowIndex" pTemplate="input">
      <td>
         <input pInputText min="0" (ngModelChange)="onInputChange($event, col.field, rowData)" class="input-custom" type="number" [(ngModel)]="rowData[col.field]" />
      </td>
      </ng-template>
      <ng-template pTemplate="output">
         {{ rowData[col.field] }}
      </ng-template>
      </p-cellEditor>
      </div>
      </td>

      <td [pEditableColumn]="rowData[col.field]" pEditableColumnField="col.field"
         *ngIf="rowData[col.field+'ControlType'] == 3" [ngClass]="getTextAlignmentClass(col.dataType)">
         <div class="editable-datepickerr">
            <p-cellEditor>
               <ng-template let-rowIndex="rowIndex" pTemplate="input">
                  <p-calendar [style]="{'width':'100%'}" [showButtonBar]="true" dateFormat="yy-mm-dd"
                     styleClass="editable-datepicker" [(ngModel)]="rowData[col.field]" appendTo="body"
                     (ngModelChange)="onDateChange($event, col.field, rowData)">
                  </p-calendar>
               </ng-template>
               <ng-template pTemplate="output">
                  {{ rowData[col.field] | date : 'yyyy-MM-dd' }}
               </ng-template>
            </p-cellEditor>
         </div>
      </td>
      <td [pEditableColumn]="rowData[col.field]" pEditableColumnField="col.field" 
         *ngIf="rowData[col.field+'ControlType'] == 4" [ngClass]="getTextAlignmentClass(col.dataType)">
         <div class="editable-datepickerr">
            <p-cellEditor>
               <ng-template let-rowIndex="rowIndex" pTemplate="input">
      <td>
         <input pInputText min="0" class="input-custom" type="text" [(ngModel)]="rowData[col.field]" 
         (ngModelChange)="onInputChange($event, col.field, rowData)" (blur)="handleBlur($event, col.field, rowData)" />
      </td>
      </ng-template>
      <ng-template pTemplate="output">
         {{ rowData[col.field] }}
      </ng-template>
      </p-cellEditor>
      </div>
      </td>
   </ng-container>
</ng-container>
</tr>
</ng-template>

<ng-template pTemplate="emptymessage">
   <tr>
      <td *ngIf="showEmptyMessage">No data found.</td>
   </tr>
</ng-template>

</p-table>

<neo-matris-paginator *ngIf="showPaginator" class="custom-paginator" [showCurrentPageReport]="true"
   currentPageReportTemplate="{first} - {last} of {totalRecords}" (pageChange)="onPageChange($event)" [first]="first"
   [rows]="20" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]"></neo-matris-paginator>

</div>